export default __webpack_public_path__ + "static/media/324.cc84aa59.gif";